import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import * as Sentry from '@sentry/angular';
import { LocalStorageService } from '@services/local-storage.service';
import { DefaultGUID } from 'src/app/@shared/constants/Constant';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { LoginService } from 'src/app/service/login.service';
import { MemberService } from 'src/app/service/member.service';
import { IAssignedRole, IMemberClaims } from 'src/app/service/memeber.model';
import { SidebarUserInfoComponent } from '../sidebar-user-info/sidebar-user-info.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-sidebar-switch-role',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatRadioModule, SidebarUserInfoComponent],
  templateUrl: './sidebar-switch-role.component.html',
  styleUrls: ['./sidebar-switch-role.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarSwitchRoleComponent implements OnInit {
  @Input() currentUser: ILoggedInUserViewModel | null = null;

  @Output() backClicked = new EventEmitter<void>();

  user: ILoggedInUserViewModel;

  constructor(
    private _memberService: MemberService,
    private _loginService: LoginService,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
  }

  switchRole(role: IAssignedRole): void {
    this.getMemberClaimsBasedOnRoleId(role.roleId).subscribe((newClaims) => {
      if (newClaims.length > 0) {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.user.role = role.roleName;
        this.user.roleId = role.roleId;
        this.user.claims = newClaims;
        localStorage.setItem('user', JSON.stringify(this.user));
        this.redirectToRoleRespectiveDashboard();
        this.populateUserDataForSentry();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    });
  }

  switchOrganization(organization: any) {
    this.user.businessUnitId = organization.id;
    this.user.businessUnitName = organization.name;
    this.user.roleId = DefaultGUID;
    this.localStorageService.setCurrentUserDetails(this.user);
    this._memberService.getMemberDetails().subscribe((user) => {
      this.localStorageService.setCurrentUserDetails(user);
      this.redirectToRoleRespectiveDashboard(user?.role);
      this.populateUserDataForSentry();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  }

  getMemberClaimsBasedOnRoleId(roleId: string): Observable<IMemberClaims[]> {
    return this._memberService.getMemberClaimsBasedOnRoleId(roleId);
  }

  public redirectToRoleRespectiveDashboard(role?: string): void {
    this._loginService.redirectToRespectiveDashboard(role || this.user?.role);
  }

  private populateUserDataForSentry(): void {
    const user = this.user;
    if (user) {
      Sentry.setUser({
        id: user.memberId,
        email: user.emailID,
        username: user.fullName,
        role: user.role,
      });
    }
  }
}
